
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings",
      function () {
        return require("private-next-pages/[company]/settings/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/settings"])
      });
    }
  